import { render, staticRenderFns } from "./BulkImportUpload.vue?vue&type=template&id=52795a75"
import script from "./BulkImportUpload.vue?vue&type=script&lang=ts"
export * from "./BulkImportUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports